import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useColorScheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { cx } from 'ramda-extension';

import AvatarHead from 'components/atoms/CustomSVGIcon/AvatarHead';

const Sidebar = ({ title, children, className, contextUser, sx, ...rest }) => {
	const { mode: appTheme } = useColorScheme();

	return (
		<Stack
			sx={{ ...sx, backgroundColor: (theme) => theme.palette.background[100] }}
			className={cx('SidebarWrapper', className)}
			{...rest}
		>
			{contextUser && (
				<Section
					className="Sidebar-userContext"
					direction="row"
					sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
				>
					<Box sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
						<AvatarHead className="Sidebar-icon" />
					</Box>
					<Typography variant="subtitle" color="text.primary">
						{contextUser.surname || ''} {contextUser.firstName || ''}
					</Typography>
				</Section>
			)}
			{title && (
				<Stack sx={{ backgroundColor: appTheme === 'light' ? 'grey.400' : 'background.300' }}>
					<Typography
						variant="subtitle1"
						color="common.white"
						noWrap
						sx={{
							p: 1,
							pl: 2,
						}}
					>
						{title}
					</Typography>
				</Stack>
			)}
			{children}
		</Stack>
	);
};

const Body = ({ children, className, ...rest }) => (
	<Stack className={cx('Sidebar-main', className)} {...rest}>
		{children}
	</Stack>
);

const Footer = ({ children, className, ...rest }) => (
	<Stack className={cx('Sidebar-footer', className)} {...rest}>
		{children}
	</Stack>
);

const Section = ({ heading, children, className, last, ...rest }) => (
	<Stack className={cx('SidebarSection', className, { 'SidebarSection--last': last })} {...rest}>
		{heading && <div className="SidebarSection-heading">{heading}</div>}
		{children}
	</Stack>
);

Body.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
};

Footer.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
};

Section.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	heading: PropTypes.string,
	last: PropTypes.bool,
};

Sidebar.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	contextUser: PropTypes.object,
	hidden: PropTypes.bool,
	sx: PropTypes.object,
	title: PropTypes.string,
};

Sidebar.Body = Body;
Sidebar.Footer = Footer;
Sidebar.Section = Section;

export default Sidebar;
